import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  dialog: {
    borderRadius: "12px !important",
    [theme.breakpoints.down("md")]: {
      width: "90%",
      height: "auto",
    },
  },
  dialogHeader: {
    fontSize: "16px",
    color: theme.palette.grey["800"],
    fontWeight: 600,
  },
  dialogMessage: {
    fontSize: "12px",
    color: theme.palette.grey["800"],
    lineHeight: "16px",
    marginTop: "10px",
  },
  confirmButton: {
    minWidth: "130px",
    fontSize: "12px",
    fontWeight: 700,
    color: "#FFFFFF",
    backgroundColor: "#1E49E2",
    "&:hover": {
      backgroundColor: "#1E49E2",
      outline: "2px solid #000000",
    },
  },
  cancelButton: {
    minWidth: "130px",
    padding: "5px 18px",
    fontSize: "12px",
    fontWeight: 700,
    color: theme.palette.grey["800"],
    backgroundColor: "#E6E6E6",
    "&:hover": {
      outline: "2px solid #000000",
    },
  },
}));
